import React from 'react'
import Table1 from './Table1'
import SalesDetails from './SalesDetails'
function Tab4({ formData, onFieldChange, extraData }) {
    return (
        <div className="px-4 py-4" style={{ background: 'white' }}>
            <SalesDetails
                formData={formData}
                onFieldChange={onFieldChange}
                extraData={extraData}
            />

            <Table1
                title="Customer Details "
                setselected_item_data={[]}
                createNewRow={[]}
                columns={extraData.ItemColumnsTab4Table1}
                rows={[]}
                setRows={() => { }}
                list_data={() => { }}
                po_status={""}
            />

        </div>
    )
}

export default Tab4
